import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";

export class AddOrUpdateInmatningTestCommand extends BasicCommand<AddOrUpdateInmatningTestCommand> {
    get primaryKey() {
        return {
            guid: this.guid
        };
    }
    handelseNr: string;
    virkesordernummer: string;
    status: string;
    feature: string;
    parameter: string;
    guid: string;
    accessToken: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "AddOrUpdateInmatningTestCommand";
    constructor(init: (instance: AddOrUpdateInmatningTestCommand) => void) {
        super("AddOrUpdateInmatningTestCommand", "InmatningTest", CommandType.Replace);
        init(this);
    }
}
